// js file - NO AUTO-SNAP VERSION
// Pricing delegated to window.DnkPricing (registered by the active cart mode script).
(function () {
  const SECTION_SELECTOR = '.customers-also-bought';

  function formatMoney(cents) {
    const value = Math.round(Number(cents || 0) / 100) * 100;

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        const format =
          (window.theme && window.theme.moneyFormat) ||
          window.Shopify.money_format ||
          '{{amount_no_decimals}}';
        let formatted = window.Shopify.formatMoney(value, format);
        // Replace "Rs." or "Rs " with "₹"
        formatted = formatted.replace(/Rs\.?\s*/gi, '₹');
        formatted = formatted.replace(/:\s*/, ' ');
        // Drop paise decimals to match the main PDP price display (₹134.65 -> ₹134)
        formatted = formatted.split('.')[0];
        return formatted;
      } catch (e) {
        // fall through
      }
    }

    // simple fallback: no decimals, INR-style prefix
    return '₹' + Math.round(value / 100);
  }

  /**
   * Safely parse a Shopify variant ID from either a plain integer string
   * or a GID string (gid://shopify/ProductVariant/12345).
   */
  function parseVariantId(raw) {
    if (!raw) return 0;
    const str = String(raw).trim();
    if (str.includes('/')) {
      return Number(str.split('/').pop());
    }
    return Number(str);
  }

  /**
   * Convert selected DOM card elements to the plain item objects that
   * window.DnkPricing functions expect: { variantId, price, productType }.
   * All prices in paise (Shopify's data-price values are already in paise).
   */
  function selectedToItems(selected) {
    return selected.map((item) => ({
      variantId: parseVariantId(item.dataset.variantId),
      price: Number(item.dataset.price || 0),
      productType: (item.dataset.productType || '').trim(),
      productId: item.dataset.productId || '',
    }));
  }

  /**
   * Discounted total in paise.
   * Delegates to window.DnkPricing.calcBundleTotal(), which is registered by
   * whichever cart-mode script is active for the current theme mode:
   *   cart-mode-bau.js    → BAU amount-based tier
   *   cart-mode-ip-sale.js → IP Sale product-count tier
   *   bogo-script.js      → BOGO buy-X-get-Y
   * No mode-switching needed here — the right implementation is always in place.
   */
  function getTotalPricePaise(selected) {
    if (!selected.length) return 0;

    const pricing = window.DnkPricing;
    if (!pricing || typeof pricing.calcBundleTotal !== 'function') {
      // Fallback: no discount (should not happen in production)
      return selected.reduce((sum, item) => sum + Number(item.dataset.price || 0), 0);
    }

    return pricing.calcBundleTotal(selectedToItems(selected));
  }

  function initCustomersAlsoBought(root = document) {
    const sections = root.querySelectorAll(SECTION_SELECTOR);
    if (!sections.length) return;

    const COUNT_WORDS = [
      'zero',
      'one',
      'two',
      'three',
      'four',
      'five',
      'six',
      'seven',
      'eight',
      'nine',
      'ten',
      'eleven',
      'twelve',
      'thirteen',
      'fourteen',
      'fifteen',
    ];

    sections.forEach((section) => {
      if (section.dataset.customersAlsoBoughtInitialized === 'true') return;
      section.dataset.customersAlsoBoughtInitialized = 'true';

      const list = section.querySelector('[data-customers-also-bought-list]');
      const summary = section.querySelector('[data-customers-also-bought-summary]');
      const button = section.querySelector('[data-customers-also-bought-atc]');
      const items = list ? Array.from(list.querySelectorAll('[data-customers-also-bought-item]')) : [];

      if (!list || !summary || !button || !items.length) return;

      const addAllOne = section.dataset.addAllOne || 'Add all one';
      const soldOutLabel = section.dataset.soldOutLabel || 'Sold out';

      // Pre-rendered button span references — no innerHTML mutation on recalc
      const btnLabel = button.querySelector('[data-btn-label]');
      const btnCompare = button.querySelector('[data-btn-compare]');
      const btnPrice = button.querySelector('[data-btn-price]');
      const btnDiscount = button.querySelector('[data-btn-discount]');

      function getSelectedItems() {
        return items.filter((item) => item.classList.contains('is-active'));
      }

      // Only rebuild inputs when selection actually changes
      let prevSelectedKey = '';

      function updateFormInputs() {
        const form = summary.querySelector('form');
        if (!form) return;

        const inputsContainer = form.querySelector('[data-bundle-inputs]');
        if (!inputsContainer) return;

        const selected = getSelectedItems();
        const currentKey = selected.map((i) => i.dataset.variantId).join(',');
        if (currentKey === prevSelectedKey) return;
        prevSelectedKey = currentKey;

        inputsContainer.innerHTML = '';
        selected.forEach((item, index) => {
          const variantId = parseVariantId(item.dataset.variantId);
          if (!variantId) return;

          inputsContainer.insertAdjacentHTML(
            'beforeend',
            `<input type="hidden" name="items[${index}][id]" value="${variantId}">` +
              `<input type="hidden" name="items[${index}][quantity]" value="1">`
          );
        });
      }

      const isBogoMode = section.dataset.rewardType === 'Bogo';

      /**
       * BOGO mode only: marks which selected cards are the free unit(s) and
       * updates each card's own price/compare-at/badge to match — mirrors the
       * exact algorithm in assets/bogo-script.js's applyBogo() (cheapest units
       * first, normal items max 4 free, combo items max 1 free) so the per-card
       * display always agrees with the aggregate total from calcBundleTotal().
       * No-op in every other mode; every card is reset to its own recorded
       * price first so toggling selection or switching modes never leaves a
       * stale free tag behind.
       */
      function applyBogoDisplay(selected) {
        items.forEach((item) => {
          const priceEl = item.querySelector('[data-item-price]');
          const compareEl = item.querySelector('[data-item-compare-at-price]');
          const badgeEl = item.querySelector('[data-item-free-badge]');
          const price = Number(item.dataset.price || 0);
          const compareAt = Number(item.dataset.compareAtPrice || 0);

          if (priceEl) priceEl.textContent = formatMoney(price);
          if (compareEl) {
            if (compareAt > price && compareAt > 0) {
              compareEl.textContent = formatMoney(compareAt);
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }
          if (badgeEl) badgeEl.hidden = true;
        });

        if (!isBogoMode || !selected.length) return;

        const entries = selected.map((item) => ({
          item,
          price: Number(item.dataset.price || 0),
          isCombo: (item.dataset.productType || '').toLowerCase().includes('combo'),
          isFree: false,
        }));

        function markFree(list, maxFree) {
          const sorted = list.slice().sort((a, b) => a.price - b.price);
          const freeCount = Math.min(maxFree, Math.floor(sorted.length / 2));
          sorted.slice(0, freeCount).forEach((entry) => { entry.isFree = true; });
        }

        markFree(entries.filter((entry) => !entry.isCombo), 4);
        markFree(entries.filter((entry) => entry.isCombo), 1);

        entries.forEach(({ item, price, isFree }) => {
          if (!isFree) return;
          const priceEl = item.querySelector('[data-item-price]');
          const compareEl = item.querySelector('[data-item-compare-at-price]');
          const badgeEl = item.querySelector('[data-item-free-badge]');

          if (priceEl) priceEl.textContent = formatMoney(100); // BOGO free unit = ₹1
          if (compareEl) {
            compareEl.textContent = formatMoney(price);
            compareEl.hidden = false;
          }
          if (badgeEl) badgeEl.hidden = false;
        });
      }

      function recalcTotals() {
        const totalPriceEl = summary.querySelector('[data-total-price]');
        const totalCompareEl = summary.querySelector('[data-total-compare-at]');

        const selected = getSelectedItems();
        applyBogoDisplay(selected);

        // Compare price = sum of original selling prices (data-price) for all modes.
        // This is the "before discount" reference shown as the strikethrough amount.
        const totalCompare = selected.reduce(
          (sum, item) => sum + Number(item.dataset.price || 0), 0
        );

        const totalPrice = getTotalPricePaise(selected);

        if (totalPriceEl) {
          totalPriceEl.textContent = formatMoney(totalPrice);
        }

        const discount = totalCompare > 0 ? totalCompare - totalPrice : 0;
        const hasDiscount = discount > 0 && totalCompare > 0 && totalPrice > 0;

        if (totalCompareEl) {
          if (hasDiscount) {
            totalCompareEl.textContent = formatMoney(totalCompare);
            totalCompareEl.hidden = false;
          } else {
            totalCompareEl.hidden = true;
          }
        }

        // Block the Add-all action when any selected card's variant is out of stock.
        // Only the first (current-product) card can become unavailable at runtime —
        // it follows the PDP variant selection; all other cards render available-only.
        const hasUnavailable = selected.some((item) => item.dataset.available === 'false');
        button.disabled = !selected.length || hasUnavailable;

        const count = selected.length;
        const isMobile = window.matchMedia('(max-width: 749px)').matches;

        if (hasUnavailable) {
          if (btnLabel) btnLabel.textContent = soldOutLabel;
          if (btnCompare) btnCompare.hidden = true;
          if (btnPrice) btnPrice.hidden = true;
          if (btnDiscount) btnDiscount.hidden = true;
        } else if (isMobile) {
          const safeCount = Math.max(1, Math.min(count, 15));
          const discountPercent = hasDiscount ? Math.round((discount / totalCompare) * 100) : 0;

          if (btnLabel) btnLabel.textContent = 'Add all ' + COUNT_WORDS[safeCount];
          if (btnCompare) {
            btnCompare.textContent = hasDiscount ? formatMoney(totalCompare) : '';
            btnCompare.hidden = !hasDiscount;
          }
          if (btnPrice) {
            btnPrice.textContent = formatMoney(totalPrice);
            btnPrice.hidden = false;
          }
          if (btnDiscount) {
            btnDiscount.textContent = hasDiscount ? discountPercent + '%off' : '';
            btnDiscount.hidden = !hasDiscount;
          }
        } else {
          // Desktop: show only the label, hide price spans
          const safeCount = Math.max(1, Math.min(count || 1, 15));
          if (btnLabel) btnLabel.textContent = count ? 'Add all ' + COUNT_WORDS[safeCount] : addAllOne;
          if (btnCompare) btnCompare.hidden = true;
          if (btnPrice) btnPrice.hidden = true;
          if (btnDiscount) btnDiscount.hidden = true;
        }

        // "Save ₹X when you buy this pair" — whenever the selection has a real saving
        const savingsEl = summary.querySelector('[data-cab-savings]');
        if (savingsEl) {
          const showSavings = !hasUnavailable && count > 0 && hasDiscount;
          if (showSavings) {
            const amountEl = savingsEl.querySelector('[data-cab-savings-amount]');
            const groupEl = savingsEl.querySelector('[data-cab-savings-group]');
            if (amountEl) amountEl.textContent = formatMoney(discount);
            if (groupEl) {
              groupEl.textContent = count === 1 ? 'this product' : count === 2 ? 'this pair' : 'these pairs';
            }
          }
          savingsEl.hidden = !showSavings;
          savingsEl.removeAttribute('data-cab-savings-pending');
        }

        updateFormInputs();
      }

      function toggleCard(card) {
        const pressedBtn = card.querySelector('.customers-also-bought__checkbox-button');
        const isActive = card.classList.toggle('is-active');
        if (pressedBtn) {
          pressedBtn.setAttribute('aria-pressed', String(isActive));
        }
        recalcTotals();
      }

      // Replace "Rs." with "₹" in Liquid-rendered prices
      function replaceRsInPrices() {
        const priceElements = section.querySelectorAll(
          '[data-item-price], [data-item-compare-at-price]'
        );
        priceElements.forEach((el) => {
          if (el.textContent) {
            el.textContent = el.textContent.replace(/Rs\.?\s*/gi, '₹');
          }
        });
      }

      recalcTotals();

      // Replace Rs. in Liquid-rendered prices
      replaceRsInPrices();

      let lastMobile = window.matchMedia('(max-width: 749px)').matches;
      window.addEventListener('resize', () => {
        const nowMobile = window.matchMedia('(max-width: 749px)').matches;
        if (nowMobile !== lastMobile) {
          lastMobile = nowMobile;
          recalcTotals();
        }
      });

      // Checkbox + card click handlers
      items.forEach((item) => {
        const checkboxBtn = item.querySelector('.customers-also-bought__checkbox-button');
        if (!checkboxBtn) return;

        checkboxBtn.addEventListener('click', (event) => {
          event.stopPropagation();
          toggleCard(item);
        });

        item.addEventListener('click', (event) => {
          if (event.target.closest('a')) return;
          if (event.target.closest('.customers-also-bought__checkbox-button')) return;
          if (event.target.closest('[data-cab-variant-selector]')) return;
          if (list.dataset.justDragged === 'true') return;
          toggleCard(item);
        });
      });

      list.addEventListener('click', (event) => {
        const varBtn = event.target.closest('[data-cab-variant-btn]');
        if (!varBtn) return;
        event.stopPropagation();

        const card = varBtn.closest('[data-customers-also-bought-item]');
        if (!card) return;

        // First card variant is driven by the PDP selector — disallow manual switching
        if (card.dataset.isCurrentProduct === 'true') return;

        card.querySelectorAll('[data-cab-variant-btn]').forEach((btn) => {
          btn.classList.remove('is-selected');
          btn.setAttribute('aria-pressed', 'false');
        });
        varBtn.classList.add('is-selected');
        varBtn.setAttribute('aria-pressed', 'true');

        const colorText = card.querySelector('.selected-color-name');
        if (colorText && varBtn.classList.contains('color_buttons')) {
          colorText.textContent = varBtn.getAttribute('aria-label') || '';
        }

        card.dataset.variantId = varBtn.dataset.variantId;
        card.dataset.price = varBtn.dataset.price;
        card.dataset.compareAtPrice = varBtn.dataset.compareAtPrice || '0';

        const imgEl = card.querySelector('.customers-also-bought__image-link img');
        if (imgEl && varBtn.dataset.image) {
          imgEl.removeAttribute('srcset');
          imgEl.src = varBtn.dataset.image;
          imgEl.closest('picture')?.querySelectorAll('source').forEach((s) => {
            s.srcset = varBtn.dataset.image;
          });
        }

        const titleSpan = card.querySelector('[data-variant-title]');
        if (titleSpan) titleSpan.textContent = varBtn.dataset.title || '';

        const priceEl = card.querySelector('[data-item-price]');
        const compareEl = card.querySelector('[data-item-compare-at-price]');
        const price = Number(varBtn.dataset.price || 0);
        const compareAt = Number(varBtn.dataset.compareAtPrice || 0);
        if (priceEl) priceEl.textContent = formatMoney(price);
        if (compareEl) {
          if (compareAt > price && compareAt > 0) {
            compareEl.textContent = formatMoney(compareAt);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        if (card.classList.contains('is-active')) recalcTotals();
      });

      async function addSelectedToCart() {
        const selected = getSelectedItems();
        if (!selected.length) return;
        // Never add an out-of-stock selection to the cart
        if (selected.some((item) => item.dataset.available === 'false')) return;

        const itemsPayload = selected
          .map((item) => ({
            id: parseVariantId(item.dataset.variantId),
            quantity: 1,
          }))
          .filter((item) => item.id > 0);

        button.disabled = true;
        button.classList.add('loading');
        const btnContent = button.querySelector('[data-btn-content]');
        const btnLoader = button.querySelector('[data-button-loader]');
        if (btnContent) btnContent.classList.add('invisible');
        if (btnLoader) { btnLoader.classList.remove('hidden'); btnLoader.classList.add('flex'); }

        try {
          // Step 1: Add items to cart
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items: itemsPayload }),
          });

          if (!response.ok) {
            throw new Error('Cart add failed');
          }

          await response.json();

          // Step 2: Fetch fresh cart sections and open the drawer.
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            const sectionsRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
            if (sectionsRes.ok) {
              const sectionsData = await sectionsRes.json();
              if (typeof cartDrawer.renderContentsCustom === 'function') {
                cartDrawer.renderContentsCustom(sectionsData, true);
              } else if (typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents({ sections: sectionsData });
                if (typeof cartDrawer.open === 'function') cartDrawer.open();
              } else if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              }

              // Rendering the drawer directly bypasses the PUB_SUB_EVENTS.cartAdd
              // flow. The active cart-mode script (cart-mode-bau.js /
              // cart-mode-ip-sale.js) recomputes each line's discounted price and
              // compare-at strikethrough on cartUpdate — without this publish the
              // drawer shows raw undiscounted prices. Mirrors searchtap-collection.js.
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'customers-also-bought' });
              }
            }
          }
        } catch (e) {
          console.error('customers-also-bought: error adding items to cart', e);
        } finally {
          button.disabled = false;
          button.classList.remove('loading');
          const btnContentEnd = button.querySelector('[data-btn-content]');
          const btnLoaderEnd = button.querySelector('[data-button-loader]');
          if (btnContentEnd) btnContentEnd.classList.remove('invisible');
          if (btnLoaderEnd) { btnLoaderEnd.classList.add('hidden'); btnLoaderEnd.classList.remove('flex'); }
        }
      }

      const form = summary.querySelector('form');
      if (form) {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          addSelectedToCart();
        });
      }

      // Update the current-product card when PDP variant changes
      const currentProductCard = list.querySelector('[data-is-current-product]');
      if (currentProductCard) {
        function updateCurrentProductCard({ variantId, price, compareAtPrice, imageSrc, available }) {
          currentProductCard.dataset.variantId = variantId;
          currentProductCard.dataset.price = price;
          currentProductCard.dataset.compareAtPrice = compareAtPrice;

          // Track availability of the PDP-driven variant. When it's out of stock,
          // hide this card's variant selector and let recalcTotals() block Add-all.
          const isUnavailable = available === false;
          currentProductCard.dataset.available = isUnavailable ? 'false' : 'true';
          const variantSelector = currentProductCard.querySelector('[data-cab-variant-selector]');
          if (variantSelector) variantSelector.hidden = isUnavailable;

          const priceEl = currentProductCard.querySelector('[data-item-price]');
          const compareEl = currentProductCard.querySelector('[data-item-compare-at-price]');

          if (priceEl) priceEl.textContent = formatMoney(price);
          if (compareEl) {
            if (compareAtPrice > price && compareAtPrice > 0) {
              compareEl.textContent = formatMoney(compareAtPrice);
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }

          // render 'image' wraps <img> in <picture>; query the <img> directly
          // and sync <source> srcsets so the picture element reflects the new variant image
          if (imageSrc) {
            const imgEl = currentProductCard.querySelector('.customers-also-bought__image-link img');
            if (imgEl) {
              imgEl.src = imageSrc;
              imgEl.closest('picture')?.querySelectorAll('source').forEach((s) => {
                s.srcset = imageSrc;
              });
            }
          }

          const variantBtns = currentProductCard.querySelectorAll('[data-cab-variant-btn]');
          if (variantBtns.length) {
            const targetId = parseVariantId(variantId);
            variantBtns.forEach((btn) => {
              const match = parseVariantId(btn.dataset.variantId) === targetId;
              btn.classList.toggle('is-selected', match);
              btn.setAttribute('aria-pressed', String(match));
            });
            const colorText = currentProductCard.querySelector('.selected-color-name');
            if (colorText) {
              const selectedBtn = currentProductCard.querySelector('[data-cab-variant-btn].is-selected');
              colorText.textContent = selectedBtn ? (selectedBtn.getAttribute('aria-label') || '') : '';
            }
          }

          if (currentProductCard.classList.contains('is-active')) {
            recalcTotals();
          }
        }

        // Custom event from npdp-details.js handleOptionClick
        document.addEventListener('dnk:pdp:variant-change', (event) => {
          updateCurrentProductCard(event.detail);
        });

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          const cardProductId = currentProductCard.dataset.productId;
          subscribe(PUB_SUB_EVENTS.variantChange, (data) => {
            if (String(data.productId) !== String(cardProductId)) return;
            const variant = data.variant;
            if (!variant) return;
            // pubsub variant objects don't include featured_image — look it up from the rendered button
            const matchingBtn = currentProductCard.querySelector(
              `[data-cab-variant-btn][data-variant-id="${variant.id}"]`
            );

            // Variant-level discount (vd_discount_paise, set by pdp-variants.liquid) takes
            // priority over compare_at_price and is applied BEFORE the bundle discount
            // engine — same rule as the Liquid render. price becomes data-price, which
            // feeds window.DnkPricing.calcBundleTotal().
            const vdDiscountPaise = Number(variant.vd_discount_paise || 0);
            const price = vdDiscountPaise > 0 ? Math.max(variant.price - vdDiscountPaise, 0) : variant.price;
            const compareAtPrice = vdDiscountPaise > 0 ? variant.price : (variant.compare_at_price || 0);

            updateCurrentProductCard({
              variantId: variant.id,
              price,
              compareAtPrice,
              imageSrc: matchingBtn ? matchingBtn.dataset.image || null : null,
              available: variant.available,
            });
          });
        }
      }

      // Mouse drag to swipe carousel (desktop)
      let isDragging = false;
      let dragStartX = 0;
      let dragScrollLeft = 0;
      let hasDragged = false;

      function onListMouseDown(e) {
        if (e.target.closest('a') || e.target.closest('button')) return;
        isDragging = true;
        hasDragged = false;
        dragStartX = e.clientX;
        dragScrollLeft = list.scrollLeft;
        list.classList.add('is-dragging');
      }

      function onDocumentMouseMove(e) {
        if (!isDragging) return;
        e.preventDefault();
        const dx = dragStartX - e.clientX;
        list.scrollLeft = dragScrollLeft + dx;
        dragStartX = e.clientX;
        dragScrollLeft = list.scrollLeft;
        hasDragged = true;
      }

      function onDocumentMouseUp() {
        if (!isDragging) return;
        isDragging = false;
        list.classList.remove('is-dragging');
        if (hasDragged) {
          list.dataset.justDragged = 'true';
          setTimeout(() => delete list.dataset.justDragged, 50);
        }
      }

      list.addEventListener('mousedown', onListMouseDown);
      document.addEventListener('mousemove', onDocumentMouseMove, { passive: false });
      document.addEventListener('mouseup', onDocumentMouseUp);
      list.addEventListener('mouseleave', onDocumentMouseUp);

    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initCustomersAlsoBought(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target;
    if (container && container.querySelector(SECTION_SELECTOR)) {
      initCustomersAlsoBought(container);
    }
  });
})();
